__turbopack_context__.v({
  "closeButton": "styles-module__4Vh-ya__closeButton",
  "footerText": "styles-module__4Vh-ya__footerText",
  "freeShippingText": "styles-module__4Vh-ya__freeShippingText",
  "headerContainer": "styles-module__4Vh-ya__headerContainer",
  "marketplaceFeesBenefitsList": "styles-module__4Vh-ya__marketplaceFeesBenefitsList",
  "modalContent": "styles-module__4Vh-ya__modalContent",
  "price": "styles-module__4Vh-ya__price",
  "row": "styles-module__4Vh-ya__row",
  "shippingBannerSpacing": "styles-module__4Vh-ya__shippingBannerSpacing",
  "totalPrice": "styles-module__4Vh-ya__totalPrice",
});
